import FastMarquee from "react-fast-marquee";

export const Marquee = ({ items, speed = 28, dark = false }) => (
  <div className={`py-8 md:py-10 border-y ${dark ? "bg-forest border-cream/10" : "bg-sand/60 border-moss/15"}`} data-testid="editorial-marquee">
    <FastMarquee speed={speed} gradient={false} autoFill pauseOnHover>
      {items.map((t, i) => (
        <span key={t} className="flex items-center">
          <span className={`px-6 md:px-10 text-4xl md:text-6xl leading-none ${i % 2 ? "font-display font-extrabold" : "serif-i"} ${dark ? "text-cream" : "text-moss"}`}>{t}</span>
          <svg viewBox="0 0 20 20" className={`w-5 h-5 ${dark ? "text-lime" : "text-sage"}`} aria-hidden="true"><path d="M10 0c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10z" fill="currentColor" /></svg>
        </span>
      ))}
    </FastMarquee>
  </div>
);
